import React from 'react';
import { SaveButton, Toolbar } from 'react-admin';
import { Typography, Box } from '@mui/material';
import { useFormState } from 'react-hook-form';

const PermanentPlacementFormToolbar = () => {
  const { isSubmitSuccessful, errors } = useFormState();

  return (
    <Toolbar>
      <SaveButton label="Save" alwaysEnable />
      {!isSubmitSuccessful && errors?.custom_error?.message && (
        <Box ml={3}>
          <Typography color="error">{errors.custom_error.message as string}</Typography>
        </Box>
      )}
    </Toolbar>
  );
};

export default PermanentPlacementFormToolbar;
